export const MuiCheckbox = (palette) => ({
  root: {
    color: palette.primary.main,
  },
})
